import React, { useEffect, useRef, useState } from 'react';
import LocationIconHeader from '../Icons/LocationIconHeader';
import DropUpArrow from '../Icons/DropUpArrow';
import DropDownArrow from '../Icons/DropDownArrow';
import eventClickHomepage from '../../../helpers/emarsys/homepage/eventClickHomepage';

const GeoPosition = ({
  withIcon = true,
  withChevron = false,
  large = false,
  classNameContainer = '',
  navBar = false,
  value = '',
  onChange = () => {},
  options = [],
  onShowModal = () => {},
}: {
  withIcon?: boolean;
  withChevron?: boolean;
  large?: boolean;
  classNameContainer?: string;
  navBar?: boolean;
  value?: string;
  onChange?: (value?: string) => void;
  options?: string[];
  onShowModal?: () => void;
}) => {
  const className = ['relative', classNameContainer];
  const [isOpen, setIsOpen] = useState(false);
  const refDropdown = useRef(null);

  const handleClickLocation = (event) => {
    setIsOpen((prevValue) => !prevValue);
    if (event.target.matches('.drop-down-arrow')) {
      setIsOpen((prevValue) => !prevValue);
    }
  };

  const closeOpenMenus = (e) => {
    if (isOpen && refDropdown.current && !refDropdown.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handleSelectLocation = (location) => {
    onChange(location);
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('click', closeOpenMenus);
    return () => {
      document.removeEventListener('click', closeOpenMenus);
    };
  }, [isOpen]);

  return (
    <div
      className={className.join(' ')}
      onClick={() => eventClickHomepage('homepage auto2000', 'header category', 'pilih lokasi')}
    >
      <div
        id="nav-geo"
        className="flex gap-1 items-center md:border-b md:border-reliableBlack10 lg:border-none cursor-pointer h-10 justify-center px-[6px]"
        onClick={navBar ? onShowModal : handleClickLocation}
        ref={refDropdown}
      >
        {withIcon && <LocationIconHeader size={20} />}
        <p className={`${large ? 'text-lg' : 'text-xs font-bold'} text-reliableBlack flex-1`}>
          {value}
        </p>
        <div
          className="drop-down-arrow"
          onClick={(event) => {
            event.stopPropagation();
            setIsOpen((prevValue) => !prevValue);
          }}
        >
          {!navBar ? withChevron && (isOpen ? <DropUpArrow /> : <DropDownArrow />) : null}
        </div>
      </div>
      {isOpen && (
        <div className="bg-white text-reliableBlack absolute top-full left-0 right-0 shadow-md max-h-56 overflow-y-scroll z-10">
          {options?.map((location) => (
            <p
              key={location}
              className={`${
                large ? 'text-lg' : 'text-xs font-bold ml-1'
              } cursor-pointer px-5 min-h-[40px] flex items-center hover:bg-gray-50`}
              onClick={() => handleSelectLocation(location)}
            >
              {location}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default GeoPosition;
